import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Angular's default strategy reuses a route's component instance whenever the future and
 * current snapshots share the same route config object — even if path params (e.g. `:id`)
 * differ. That breaks components like DetailViewComponent/AddWellComponent, which only run
 * their id-driven setup in ngOnInit: navigating from /well/A to /well/B never re-triggers it.
 * This strategy additionally requires all path params to match before reusing a route.
 */
export class AppRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // No-op: this app never detaches/caches routes.
  }

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) return false;
    return this.paramsEqual(future.params, curr.params);
  }

  private paramsEqual(a: Record<string, string>, b: Record<string, string>): boolean {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key) => a[key] === b[key]);
  }
}
